<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="aui-content aui-margin-b-15">
        <ul
          class="aui-list aui-media-list maui-list-supply"
          v-for="(item, i) in comments"
          :key="i"
        >
          <li class="aui-list-item" @click="getNews(item.id, i)">
            <div class="aui-media-list-item-inner">
              <div class="aui-list-item-media maui-supply-media">
                <div
                  v-for="(items, index) in item.pictureUrls"
                  v-if="index == 0"
                >
                  <img :src="items.url" />
                </div>
              </div>
              <div class="aui-list-item-inner maui-supply-rightbox">
                <div class="aui-list-item-text maui-flex-between">
                  <div class="maui-goods-name maui-flex-start">
                    <div>{{ item.goodsName }}</div>
                    <div class="maui-goods-class2" v-if="item.rzsp == 1">
                      <span>认</span>
                    </div>
                  </div>
                  <div>
                    <div class="maui-goods-class">
                      <span
                        v-for="(desc, index) in (
                          item.inventoryTypeName || ''
                        ).split('-')"
                        :key="desc.id"
                      >
                        <span :title="item.inventoryTypeName" v-if="index == 0"
                          >&nbsp;{{ desc }}&nbsp;</span
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="aui-list-item-text maui-flex-start"></div>
                <div class="aui-list-item-text">
                  <div class="aui-list-item-text">
                    <div class="maui-goods-price" v-if="item.sdratio == 1">
                      库存：<span style="color: #000"
                        >{{ item.goodsWeight }}{{ item.unit }}</span
                      >
                    </div>
                    <div class="maui-goods-price" v-else>
                      库存：<span style="color: #000"
                        >{{ item.goodsWeight }}{{ item.unit }}</span
                      >
                      已售数量：{{ item.spWeight - item.goodsWeight
                      }}{{ item.unit }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="sq2" v-if="item.goodsWeight == 0"></div>
            <div class="rm2" v-else></div>
            <div class="maui-bottom-list maui-bottom-box3">
              <div>
                <div v-if="item.storePrice != ''" class="maui-goods-price">
                  价格：<span style="color: #f00">{{ item.storePrice }}</span
                  >元
                </div>
                <div v-else class="maui-goods-price">期望价格：面谈</div>
              </div>
              <div class="maui-goods-ad">
                <i class="aui-iconfont aui-icon-location"></i>
                {{ item.goodsaddress }}
              </div>
              <div class="maui-bottom-box3">
                <div class="maui-goods-data">
                  {{ item.createDate | datefmt("MM/DD") }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "supplyList",
  data() {
    return {
      //noDate: false,//这是一个判断是否加载的开关
      comments: [],
      showPage: 1,
      pageSize: 10,
      pageindex: 1,
      loading: false,
      finished: false,
      totalElements: "",
      aloading: true,
      estimatedPrice: "",
      show: false,
      activeNames: ["1"],
      typelist: "",
    };
  },
  props: ["type"],
  watch: {
      type(val) {
		  if(val != 0){
			  this.pageindex = 1;
			  this.comments = [];
			  
			  this.getList(val)
		  } else {
			  this.pageindex = 1;
			  this.comments = [];
			  this.onLoad()
		  }
      },
  },
  
  // created() {
  //   this.getComments();
  // },
  created() {
  },
  methods: {
    onLoad() {
			// debugger
      this.$axios
        .get(
          "/micro/permission_order-view/spgoods/read/query?pageNo=" +
            this.pageindex +
            "&pageSize=10&sort=0&goodsClassId=&kyeWord="
        )
        .then((res) => {
          this.aloading = false;
          // this.comments = result.body.message;
          // 不替换老数据
          console.log(res.data.data);
          this.comments = this.comments.concat(res.data.data.spgoodsList);
          this.totalElements = res.data.data.totalElements;
        }); // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore(); // 加载状态结束
        this.loading = false;
        if (this.comments.length >= this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },
	
	getList(type) {
		let that = this;
		that.aloading = true;
	  this.kyeWord = this.issupplykyeWord;
	  console.log("这里是supplykyeWord " + this.issupplykyeWord);
	  this.$axios
	    .get("/mobile/goods/getGoodsPage?type="+type + "&pageNo=" + this.pageindex + "&pageSize=10",{
	      type: type,
	      goodsClass: '',
	      title: '',
	      pageNo: 1,
	      pageSize: '10'
	    })
	    .then(res => {
	      // debugger
	      that.aloading = false;
	      // that.typelist = res.data.spgoodsList;
		  
		  this.comments = this.comments.concat(res.data.spgoodsList);
		  this.totalElements = res.data.totalCount;
		  
	      console.log(res.data.spgoodsList);
	    }); // 异步更新数据
	  setTimeout(() => {
	    // 异步滑动加载数据
	    this.getMore(); // 加载状态结束
	    this.loading = false;
	    if (this.comments.length >= this.totalElements) {
	      this.finished = true;
	    }
	  }, 2000);
	},

    getMore() {
      this.pageindex++;
    },
    getNews(item, i) {
      this.$router.push({ path: "/supplyform", query: { xqid: item } });
    },
  },
};
</script>

<style scoped>
.battery-screen-wapper {
  text-align: left;
}
.battery-screen-oneji > p {
  padding: 15px 20px;
  background: #f7f8fa;
  font-size: 16px;
  font-weight: bold;
  color: #222;
}
.battery-screen-oneji {
  width: 330px;
  text-align: left;
}
.battery-screen-twoji > p {
  padding: 15px 20px;
  background: #f7f8fa;
  font-size: 16px;
  font-weight: bold;
  color: #222;
}
.battery-screen-oneji .battery-screen-onejil {
  width: 30%;
  display: inline-block;
  text-align: center;
  margin: 5px 4px;
  font-size: 14px;
}
.battery-screen-twoe > div {
  width: 30%;
  display: inline-block;
  text-align: center;
  margin: 5px 4px;
  font-size: 14px;
}
.battery-supply-vanicon {
  font-size: 14px;
}
.area-wrapper {
  background: #f2f2f2;
  display: flex;
  padding: 8px 20px;
  border-bottom: 1px solid #f2f2f2;
}
.area-wrapper div {
  font-size: 14px;
}
.battery-screen {
  margin-left: auto;
}
.maui-bar.aui-bar-nav {
  background-color: #fff;
  color: #000;
  border-bottom: solid 0.1rem #efefef;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 0.1rem #c9eee1;
  color: #3bb18a;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #000;
  font-weight: bold;
}
.aui-list {
  background: none;
}
.aui-list .aui-list-item-title.maui-news-tit {
  height: 2rem;
  line-height: 1rem;
  font-size: 0.75rem;
  color: #4f4f4f;
  overflow: hidden;
}
.aui-list .aui-list-item-text.maui-data {
  font-size: 0.65rem;
  margin: 0.2rem 0;
  color: #4f4f4f;
  justify-content: flex-end;
}

.aui-media-list .aui-list-item-inner.maui-supply-rightbox {
  /* padding: 0;
  margin: 0.7rem 0.75rem 0.7rem 0.2rem; */
  width: calc(100% - 4.75rem);
  padding-right: 0;
}
.aui-list .aui-list-item-media.maui-supply-media {
  width: 4.25rem;
  padding-top: 0.7rem;
  padding-bottom: 0.5rem;
}
.aui-list .aui-list-item-media.maui-supply-media img {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 0.2rem;
  border: solid 0.05rem #e0e0e0;
}
.aui-list .aui-list-item-text.maui-flex-between {
  justify-content: space-between;
  margin: 0.3rem 0;
}
.aui-list .aui-list-item-text.maui-flex-start {
  justify-content: flex-start;
  margin-bottom: 0.2rem;
}
.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
.maui-list-supply .aui-media-list-item-inner {
  border-bottom: solid 1px #eee;
  margin-bottom: 0.5rem;
  margin-right: 0.75rem;
}
.maui-list-supply li {
  border-bottom: 0.5rem solid #eee;
}
.maui-goods-name {
  width: 9rem;
  font-size: 0.8rem;
  color: #333;
  display: flex;
  justify-content: flex-start;
  white-space: nowrap;
}
.maui-goods-name div:first-child {
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 0.5rem;
}
.maui-goods-class {
  font-size: 0.65rem;
  color: #ffa355;
  border: solid 0.1rem;
  font-weight: bold;
}
.maui-goods-class2 {
  font-size: 0.65rem;
  background: #ffa355;
  color: #fff;
  border-radius: 0.3rem;
  line-height: 1.8;
  padding: 0 0.15rem;
}
.maui-goods-price {
  font-size: 0.65rem;
  color: #999;
  margin-right: 0.5rem;
}
.maui-goods-l {
  font-size: 0.65rem;
  color: #1b8ae0;
  border: solid 0.05rem #1b8ae0;
  padding: 0 0.2rem;
  border-radius: 0.2rem;
}
.maui-goods-l2 {
  font-size: 0.65rem;
  color: #4f4f4f;
}
.aui-list .aui-list-item-text.maui-goods-thredbox i {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad {
  font-size: 0.6rem;
  color: #999;
}
.maui-goods-ad i {
  font-size: 0.6rem;
  color: #000;
  margin-right: 0.2rem;
}
.maui-goods-data {
  font-size: 0.6rem;
  color: #4f4f4f;
}

.aui-list .aui-list-item {
  background: none;
}
.maui-bottom-box3 {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
.maui-bottom-list {
  text-align: left;
  padding-bottom: 0.5rem;
  margin-right: 0.75rem;
}
.rm2, .sq2 {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    top: 0;
}
.sq2 {
    background: url(/static/img/sq2.png) 100% no-repeat;
    background-size: 100%;
}
.rm2 {
    background: url(/static/img/rm2.png) 100% no-repeat;
    background-size: 100%;
}
</style>





// WEBPACK FOOTER //
// src/view/supplyList.vue